import React, { useEffect, useState } from 'react';
import { Modal, Divider, Header, Icon } from 'semantic-ui-react';
import { fetch } from 'services/http';

export default function AttachmentsModal(props) {
    const { attachmentId, onClose } = props;

    const [links, setLinks] = useState([]);
    //

    useEffect(() => {
        if (Boolean(attachmentId)) {
            fetch(`/control-docs/receipts/attachments/${attachmentId}`)
                .then((response) => response.json())
                .then(setLinks);
        }
    }, [attachmentId]);

    return (
        <Modal open={Boolean(attachmentId)} onClose={onClose}>
            <Modal.Content>
                {links.map((link, idx) => (
                    <>
                        <Divider id="divider-cupom" horizontal>
                            <Header as="h4">
                                <Icon name="file alternate outline" />
                                Anexo {idx + 1}
                            </Header>
                        </Divider>
                        <img key={link} src={link} alt="Anexo" />
                    </>
                ))}
            </Modal.Content>
        </Modal>
    );
}
